'use strict';
(() => {
const byId=Object.fromEntries(window.STOORZ_PRODUCTS.map(p=>[p.id,p]));
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  // The moving shades are photographic product textures, drawn over the aligned room photograph.
  const imageCache = new Map();
  function loadImage(src) { if (imageCache.has(src)) return imageCache.get(src); const result = new Promise((resolve, reject) => { const image = new Image(); image.crossOrigin = 'anonymous'; image.onload = () => resolve(image); image.onerror = () => reject(new Error('Image indisponible')); image.src = src; }); imageCache.set(src, result); return result; }
  let background;
  const textures = new Map();
  async function ensureTextures(ids) { await Promise.all(ids.map(async id => { if (!textures.has(id)) textures.set(id, await loadImage(byId[id].texture)); })); }
  class WindowScene {
    constructor(canvas, ids, openness) { this.canvas = canvas; this.ctx = canvas.getContext('2d'); this.ids = [...ids]; this.openness = [...openness]; this.frame = 0; this.generation = 0; }
    async ready() { if (!background) background = await loadImage(window.STOORZ_CONFIG.backdrop); await ensureTextures(this.ids); this.draw(); this.canvas.classList.add('ready'); }
    draw() {
      if (!background || !this.ctx) return;
      const ctx = this.ctx; ctx.clearRect(0, 0, 1536, 1024); ctx.drawImage(background, 0, 0, 1536, 1024);
      const dimensions = this.dimensions?.length === this.ids.length ? this.dimensions : null;
      const totalWidth = dimensions ? dimensions.reduce((sum, d) => sum + d.width, 0) : 1266;
      const maxHeight = dimensions ? Math.max(...dimensions.map(d => d.height)) : 530;
      const scale = dimensions ? Math.min((1266 - (this.ids.length - 1) * 3) / totalWidth, 530 / maxHeight) : 1;
      const totalPixels = dimensions ? totalWidth * scale + (this.ids.length - 1) * 3 : 1266;
      let cursor = 151 + (1266 - totalPixels) / 2;
      this.ids.forEach((id, i) => {
        const img = textures.get(id); if (!img) return;
        const w = dimensions ? Math.max(.5, dimensions[i].width * scale) : 1266 / this.ids.length - 3;
        const x = cursor; cursor += w + 3;
        const open = Math.max(0, Math.min(100, this.openness[i] ?? 30));
        const fullHeight = dimensions ? Math.max(1, dimensions[i].height * scale) : 530;
        const fabricHeight = 12 + fullHeight * (1 - open / 100);
        ctx.save(); ctx.shadowColor = 'rgba(35,20,20,.10)'; ctx.shadowBlur = 5; ctx.shadowOffsetY = 3;
        ctx.drawImage(img, 225, 164, 802, 663, x, 105, w, fabricHeight);
        ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
        ctx.drawImage(img, 224, 132, 805, 33, x - .5, 83, w + 1, 23);
        ctx.drawImage(img, 224, 825, 805, 45, x - .5, 105 + fabricHeight - 1, w + 1, 26);
        ctx.restore();
      });
    }
    animate(values, duration = 900, stagger = 0) {
      cancelAnimationFrame(this.frame); const from = [...this.openness]; const begin = performance.now();
      if (reduced.matches || duration === 0) { this.openness = [...values]; this.draw(); return; }
      const tick = now => { let done = true; this.openness = values.map((to, i) => { const t = Math.max(0, Math.min(1, (now - begin - i * stagger) / duration)); if (t < 1) done = false; const ease = 1 - Math.pow(1 - t, 4); return (from[i] ?? to) + (to - (from[i] ?? to)) * ease; }); this.draw(); if (!done) this.frame = requestAnimationFrame(tick); };
      this.frame = requestAnimationFrame(tick);
    }
    async setColors(ids) { const request = ++this.generation; await ensureTextures(ids); if (request !== this.generation) return; this.ids = [...ids]; this.draw(); }
  }

window.StoorzScene=WindowScene;
})();

// ----- Mur de fenêtres du configurateur : une fenêtre par store, à l'échelle de ses dimensions -----
(() => {
  const byId = Object.fromEntries(window.STOORZ_PRODUCTS.map(p => [p.id, p]));
  const cache = new Map();
  const load = src => { if (!cache.has(src)) cache.set(src, new Promise((ok, ko) => { const i = new Image(); i.crossOrigin = 'anonymous'; i.onload = () => ok(i); i.onerror = () => ko(new Error('Image indisponible')); i.src = src; })); return cache.get(src); };
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  class WallScene {
    constructor(canvas) { this.canvas = canvas; this.ctx = canvas.getContext('2d'); this.windows = []; this.active = 0; this.open = 22; this.hits = []; this.frame = 0; }
    async ready() { this.sky = await load(window.STOORZ_CONFIG.backdrop); await this.textures(); this.draw(); this.canvas.classList.add('ready'); }
    async textures() { await Promise.all(this.windows.map(w => load(byId[w.color].texture))); }
    async set(windows, active) { this.windows = windows.map(w => ({ ...w })); this.active = active; await this.textures().catch(() => {}); this.draw(); }
    layout() {
      const W = this.canvas.width, H = this.canvas.height, n = this.windows.length;
      const rows = n <= 4 ? 1 : n <= 8 ? 2 : 3, perRow = Math.ceil(n / rows);
      const padX = 90, padTop = 60, label = 100, gapX = 64, gapY = 36;
      const availH = (H - padTop - 30 - (rows - 1) * gapY) / rows - label;
      const groups = Array.from({ length: rows }, (_, r) => this.windows.slice(r * perRow, (r + 1) * perRow)).filter(g => g.length);
      let scale = Infinity;
      groups.forEach(g => { const sw = g.reduce((s, w) => s + w.width, 0); scale = Math.min(scale, (W - 2 * padX - gapX * (g.length - 1)) / sw, availH / Math.max(...g.map(w => w.height))); });
      if (n === 1) scale = Math.min(scale, (W * 0.6) / this.windows[0].width);
      const contentH = groups.reduce((s, g) => s + Math.max(...g.map(w => w.height * scale)) + label, 0) + gapY * (groups.length - 1);
      const out = []; let y = Math.max(padTop, (H - contentH) / 2 + 10), idx = 0;
      groups.forEach(g => {
        const rowW = g.reduce((s, w) => s + w.width * scale, 0) + gapX * (g.length - 1);
        let x = (W - rowW) / 2; const rowH = Math.max(...g.map(w => w.height * scale));
        g.forEach(w => { out.push({ i: idx++, x, y, w: w.width * scale, h: w.height * scale, win: w }); x += w.width * scale + gapX; });
        y += rowH + label + gapY;
      });
      return out;
    }
    draw() {
      const c = this.ctx, W = this.canvas.width, H = this.canvas.height; if (!c) return;
      const wall = c.createLinearGradient(0, 0, 0, H); wall.addColorStop(0, '#F7F3EA'); wall.addColorStop(1, '#EFE8DA');
      c.fillStyle = wall; c.fillRect(0, 0, W, H);
      this.hits = this.layout();
      for (const b of this.hits) {
        const f = Math.max(6, Math.min(b.w, b.h) * 0.055);
        c.save(); c.shadowColor = 'rgba(22,35,59,.18)'; c.shadowBlur = 18; c.shadowOffsetY = 8; c.fillStyle = '#FFFFFF'; c.fillRect(b.x - f, b.y - f, b.w + 2 * f, b.h + 2 * f); c.restore();
        c.fillStyle = '#E9E6DF'; c.fillRect(b.x - f - 4, b.y + b.h + f, b.w + 2 * f + 8, Math.max(4, f * 0.6));
        if (this.sky) { const sx = 160, sy = 90, sw = 1250, sh = 540, r = b.w / b.h; let cw = sw, ch = sw / r; if (ch > sh) { ch = sh; cw = sh * r; } c.drawImage(this.sky, sx + (sw - cw) / 2, sy + (sh - ch) / 2, cw, ch, b.x, b.y, b.w, b.h); }
        const tex = cache.get(byId[b.win.color].texture); const img = tex && tex._img;
        const fabricH = Math.max(10, b.h * (1 - this.open / 100));
        if (img) {
          const rail = Math.max(7, Math.min(16, b.h * 0.035));
          c.save(); c.shadowColor = 'rgba(35,20,20,.14)'; c.shadowBlur = 6; c.shadowOffsetY = 3;
          c.drawImage(img, 225, 164, 802, 663, b.x, b.y + rail, b.w, Math.max(1, fabricH - rail));
          c.restore();
          c.drawImage(img, 224, 132, 805, 33, b.x - .5, b.y, b.w + 1, rail);
          c.drawImage(img, 224, 825, 805, 45, b.x - .5, b.y + fabricH - 1, b.w + 1, rail * 1.2);
        }
        if (b.i === this.active && this.windows.length > 1) { c.strokeStyle = '#FF6B2C'; c.lineWidth = 4; c.setLineDash([]); c.strokeRect(b.x - f - 7, b.y - f - 7, b.w + 2 * f + 14, b.h + 2 * f + 14); }
        c.fillStyle = '#16233B'; c.textAlign = 'center'; c.font = '800 36px "Bricolage Grotesque", system-ui, sans-serif';
        const loc = window.STOORZ_CONFIG.locale || 'fr'; let fmt; try { fmt = v => new Intl.NumberFormat(loc, { maximumFractionDigits: 1 }).format(v); fmt(1); } catch { fmt = v => new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 }).format(v); }
        const winLabel = ((window.STOORZ_CONFIG.i18n || {}).window_n || 'Fenêtre {n}').replace('{n}', b.i + 1);
        c.fillText(winLabel, b.x + b.w / 2, b.y + b.h + f + 46);
        c.font = '600 30px "Bricolage Grotesque", system-ui, sans-serif'; c.fillStyle = '#56606f';
        c.fillText(`${fmt(b.win.width)} × ${fmt(b.win.height)} cm`, b.x + b.w / 2, b.y + b.h + f + 84);
      }
    }
    hitTest(px, py) { const r = this.canvas.getBoundingClientRect(); const x = (px - r.left) * this.canvas.width / r.width, y = (py - r.top) * this.canvas.height / r.height; const b = this.hits.find(b => x >= b.x - 10 && x <= b.x + b.w + 10 && y >= b.y - 10 && y <= b.y + b.h + 100); return b ? b.i : -1; }
    animateOpen(to, duration = 700) {
      cancelAnimationFrame(this.frame); const from = this.open, t0 = performance.now();
      if (reduced.matches || duration === 0) { this.open = to; this.draw(); return; }
      const tick = now => { const t = Math.min(1, (now - t0) / duration); this.open = from + (to - from) * (1 - Math.pow(1 - t, 3)); this.draw(); if (t < 1) this.frame = requestAnimationFrame(tick); };
      this.frame = requestAnimationFrame(tick);
    }
  }
  // garder l'image décodée à côté de la promesse pour le dessin synchrone
  const _load = load;
  window.StoorzWall = class extends WallScene {
    async textures() { await Promise.all(this.windows.map(async w => { const src = byId[w.color].texture; const p = _load(src); const img = await p; p._img = img; })); }
  };
})();
